import { TYPE_DE_VOIE } from '../constants'
import { D4_Adresse, D4_Coproprietaire } from '../types'

export class LotHelper {
  copa: D4_Coproprietaire | null = null
  adr: D4_Adresse | null | undefined = null

  constructor(copa?: D4_Coproprietaire) {
    if (copa) {
      this.copa = copa
      if (copa.mandataire) {
        this.adr = copa.mandataire.societe?.adresse
      } else if (copa.societe) {
        this.adr = copa.societe.adresse
      } else if (copa.personne) {
        this.adr = copa.personne.adresse
      } else if (copa.copropriete) {
        this.adr = copa.copropriete.adresse
      }
    }
  }

  getName(coproprietaire: D4_Coproprietaire | undefined): string {
    if (!coproprietaire) return ''

    if (coproprietaire.mandataire) {
      return `${coproprietaire.mandataire.societe?.raisonsociale}${
        coproprietaire.personne?.nom || coproprietaire.personne?.prenom
          ? `  (pour: ${coproprietaire.personne?.nom ?? ''} ${coproprietaire.personne?.prenom ?? ''})`
              .toLocaleLowerCase()
              .trim()
          : ''
      }`.trim()
    }
    if (coproprietaire.societe) {
      return coproprietaire.societe?.raisonsociale ?? ''
    }
    if (coproprietaire.personne) {
      return coproprietaire.personne?.nom ?? ''
    }
    if (coproprietaire.copropriete) {
      return coproprietaire.copropriete?.nom ?? ''
    }
    return ''
  }

  normalizeName(coproprietaire: D4_Coproprietaire | undefined): string {
    if (!coproprietaire) return ''

    if (coproprietaire.mandataire) {
      if (coproprietaire.personne) {
        const personne = `${coproprietaire.mandataire.societe?.raisonsociale}${
          coproprietaire.personne?.nom || coproprietaire.personne?.prenom
            ? `  (pour: ${coproprietaire.personne?.nom ?? ''} ${coproprietaire.personne?.prenom ?? ''})`
                .toLocaleLowerCase()
                .trim()
            : ''
        }`.trim()
        return personne
      }

      if (coproprietaire.societe) {
        const societe = `${coproprietaire.mandataire.societe?.raisonsociale}${
          coproprietaire.societe.raisonsociale
            ? `  (pour: ${coproprietaire.societe.raisonsociale})`.toLocaleLowerCase().trim()
            : ''
        }`.trim()
        return societe
      }
    }
    if (coproprietaire.societe) {
      return coproprietaire.societe?.raisonsociale?.trim() ?? ''
    }
    if (coproprietaire.personne) {
      return `${coproprietaire.personne?.nom} ${coproprietaire.personne?.prenom}`.trim()
    }
    if (coproprietaire.copropriete) {
      return coproprietaire.copropriete?.nom ?? ''
    }
    return ''
  }

  normalizeAddresse(adresse: D4_Adresse | undefined) {
    if (!adresse) return ''

    return `${adresse?.numerodanslavoie ?? ''} ${TYPE_DE_VOIE?.[adresse.typedevoie] ?? ''} ${adresse?.voie ?? ''} ${
      adresse?.complementadresse ?? ''
    } ${adresse?.batiment ? 'Bat ' + adresse.batiment : ''}  ${adresse.codepostal} ${adresse.ville}`.trim()
  }

  rue() {
    return `${this.adr?.numerodanslavoie ?? ''} ${TYPE_DE_VOIE?.[this.adr?.typedevoie] ?? ''} ${
      this.adr?.voie ?? ''
    }`.trim()
  }

  complement() {
    return `${this.adr?.complementadresse ?? ''}`
  }

  bat() {
    return `${this.adr?.batiment ? 'Bat ' + this.adr?.batiment : ''}`.trim()
  }

  cpVille() {
    return `${this.adr?.codepostal} ${this.adr?.ville}`.trim()
  }

  adresse(coproprietaire: D4_Coproprietaire | undefined): string {
    if (!coproprietaire) return ''
    if (coproprietaire.mandataire) {
      return this.normalizeAddresse(coproprietaire.mandataire.societe?.adresse as D4_Adresse)
    }
    if (coproprietaire.societe) {
      return this.normalizeAddresse(coproprietaire.societe?.adresse as D4_Adresse)
    }
    if (coproprietaire.personne) {
      return this.normalizeAddresse(coproprietaire.personne?.adresse as D4_Adresse)
    }
    if (coproprietaire.copropriete) {
      return this.normalizeAddresse(coproprietaire.copropriete?.adresse as D4_Adresse)
    }
    return ''
  }
}

export default new LotHelper()
